import { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import api, { getImageUrl } from '../services/api';
import { useSettings } from '../context/SettingsContext';
import useScrollReveal from '../hooks/useScrollReveal';

function References() {
  const { settings } = useSettings();
  const [references, setReferences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeFilter, setActiveFilter] = useState('');
  useScrollReveal();

  useEffect(() => {
    api.get('/references')
      .then(res => setReferences(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const uniqueCategories = useMemo(() => {
    const cats = references
      .map(r => r.category)
      .filter(c => c && c.trim() !== '');
    return [...new Set(cats)];
  }, [references]);

  const filteredReferences = useMemo(() => {
    if (!activeFilter) return references;
    return references.filter(r => r.category === activeFilter);
  }, [references, activeFilter]);

  return (
    <>
      <Helmet>
        <title>Referanslar | {settings.site_title || ''}</title>
        <meta property="og:title" content={`Referanslar | ${settings.site_title || ''}`} />
        <meta property="og:description" content="Tamamlanmis projelerimizden ornekler" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        {settings.logo_path && <meta property="og:image" content={`${window.location.origin}${getImageUrl(settings.logo_path)}`} />}
      </Helmet>

      <div className="page-header">
        <div className="container">
          <h1>Referanslar</h1>
          <div className="breadcrumb">
            <Link to="/">Ana Sayfa</Link> / <span>Referanslar</span>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">
          {uniqueCategories.length > 0 && (
            <div className="gallery-filters">
              <button
                className={`gallery-filter-btn${activeFilter === '' ? ' active' : ''}`}
                onClick={() => setActiveFilter('')}
              >
                Tumu
              </button>
              {uniqueCategories.map(cat => (
                <button
                  key={cat}
                  className={`gallery-filter-btn${activeFilter === cat ? ' active' : ''}`}
                  onClick={() => setActiveFilter(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
          )}

          {loading ? (
            <p>Yukleniyor...</p>
          ) : references.length === 0 ? (
            <p>Henüz referans bulunmamaktadır.</p>
          ) : (
            <div className="gallery-grid reveal">
              {filteredReferences.map(ref => (
                <div
                  key={ref.id}
                  className="gallery-item gallery-item-animated"
                  onClick={() => setSelectedImage(ref)}
                >
                  <img src={getImageUrl(ref.image_path)} alt={ref.title || 'Referans'} loading="lazy" />
                  {ref.title && (
                    <div className="gallery-overlay"><span>{ref.title}</span></div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <button className="lightbox-close" onClick={() => setSelectedImage(null)}>&times;</button>
          <img
            src={getImageUrl(selectedImage.image_path)}
            alt={selectedImage.title || 'Referans'}
            loading="lazy"
            onClick={e => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}

export default References;
